import type { EstimatedTime, Fee, Leg, NextAction, RouteMeta } from "./types.ts";

export interface SwapRequest {
  routeId: string;
  sourceAddress: string;
  destinationAddress: string;
  disableBuildTx?: boolean;
  disableBalanceCheck?: boolean;
  disableEstimate?: boolean;
  disableSecurityChecks?: boolean;
  overrideSlippage?: boolean;
}

export interface EVMTx {
  to: string;
  from: string;
  gas: string;
  gasPrice: string;
  value: string;
  data: string;
}

export interface SwapResponse {
  swapId: string;
  providers: string[];
  sellAsset: string;
  buyAsset: string;
  sellAmount: string;
  expectedBuyAmount: string;
  expectedBuyAmountMaxSlippage: string;
  targetAddress: string;
  inboundAddress?: string;
  memo?: string;
  tx: unknown;
  approvalTx?: unknown;
  fees?: Fee[];
  estimatedTime: EstimatedTime;
  totalSlippageBps: number;
  legs?: Leg[];
  warnings?: unknown[];
  meta: RouteMeta;
  nextActions?: NextAction[];
  error?: string;
  message?: string;
}

export function txAsEVM(resp: SwapResponse): EVMTx {
  return resp.tx as EVMTx;
}

export function txAsString(resp: SwapResponse): string {
  return resp.tx as string;
}
